import { globalEvent } from '@shared/easyfy.core';
import { invoke } from '@shared/easyfy.decorators';
import { toggleClass, removeCss } from '@shared/easyfy.utils';

namespace Easyfy.Modules {
  @invoke
  export class Dropdown {
    static Instance: Dropdown;

    private onChange: Function;

    constructor(change?: Function) {
      Dropdown.Instance = this;
      this.onChange = change ?? null;
    }

    onInit() {
      globalEvent({
        type: 'click',
        events: [
          {
            event: 'select-toggle',
            callback: this.onToggle
          },
          {
            event: 'select-option',
            callback: this.onOptionClick
          }
        ]
      });
    }

    onToggle(e) {
      let parent: HTMLElement = e?.target?.parentElement as HTMLElement;

      if (parent.attributes['data-event'] && parent.attributes['data-event']?.value === 'select-toggle') {
        parent = parent.parentElement as HTMLElement;
      }

      if (parent) {
        toggleClass(parent, 'open');
      }
    }

    onOptionClick(e) {
      e.preventDefault();

      let target = e?.target as HTMLElement;

      if (target.attributes['data-event']?.value !== 'select-option') {
        target = target.parentElement as HTMLElement;
      }

      const parent = target?.parentElement?.parentElement;

      if (parent && target) {
        const select: HTMLSelectElement = parent.querySelector('select');
        const selectElement: HTMLElement = parent.querySelector('[data-event="select-toggle"]');
        const optionValue = target.attributes['data-value']?.value;
        const optionText = target.innerHTML;
        const customEvent = select.attributes['data-custom-event']?.value;

        selectElement.innerHTML = optionText;
        select.value = optionValue;
        removeCss(parent, 'open');

        if (customEvent) {
          const event = document.createEvent('Event');
          event.initEvent(customEvent, true, true);
          select.dispatchEvent(event);
        }
      }

      return false;
    }
  }
}

export default Easyfy.Modules;
